import { render, staticRenderFns } from "./ForgottenPassForm.vue?vue&type=template&id=4f0075ac&"
import script from "./ForgottenPassForm.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports